module.exports = __webpack_public_path__ + "static/media/samples_per_order.b474ac0c.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/samples_per_order.csv
// module id = 698
// module chunks = 0